// extracted by mini-css-extract-plugin
export default {"list":"ICYYv0xUW2","item":"gj2N3twiSY"};